"use client";

import { useEffect, useState } from "react";
import { buttons } from "@/styles/design-tokens";

export function StickyButton() {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const scrollY = window.scrollY;
			const windowHeight = window.innerHeight;
			const documentHeight = document.documentElement.scrollHeight;
			const scrollBottom = scrollY + windowHeight;

			// Show button after scrolling 200px, but hide when close to bottom (within 200px)
			const isNearBottom = scrollBottom >= documentHeight - 200;
			setIsVisible(scrollY > 200 && !isNearBottom);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div
			className={`${isVisible ? "" : "translate-y-full"} z-50 transition-transform duration-300 ease-in-out py-6 max-w-screen-2xl mx-auto px-2 flex items-center fixed bottom-0 left-0 right-0 sm:hidden`}
		>
			<a
				href="https://calendly.com/hi-brianagude/30min"
				target="_blank"
				rel="noopener noreferrer"
				aria-label="Dianthe Studio Intro Call"
				className={`${buttons.primary}`}
			>
				{" "}
				Book an Intro Call
			</a>
		</div>
	);
}
